module.exports = __webpack_public_path__ + "img/Potencie-sua-lideranca-em-obra-com-o-reportlake.2b5ec85f.jpg";